import styled from "styled-components";

const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 600px;
  background-color: #c8f8ff;
  max-width: 976px;
  margin: auto;

  @media screen and (max-width: 976px) {
    padding: 1rem;
  }
`;

const HomeTitle = styled.h1`
  font-size: 52px;
  font-weight: bold;
  text-align: left;
  color: #2b292d;
  margin-top: 0;
  margin-bottom: 2rem;
  padding-top: 4rem;

  @media screen and (max-width: 976px) {
    font-size: 42px;
  }
`;

const HomeParagraph = styled.p`
  font-size: 24px;
  color: #2b292d;
  text-align: left;
  margin-bottom: 4rem;
  margin-top: 0;
`;

const HomeButtons = styled.div`
  display: flex;

  @media screen and (max-width: 976px) {
    flex-direction: column;
  }
`;

const MainHome = styled.div`
  display: flex;
  max-width: 976px;
  margin: auto;
`;

export { HomeContainer, HomeTitle, HomeParagraph, HomeButtons, MainHome };
